/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/metadata';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "AddFeeEventsRequest": {
                "fields": {
                  "perPaymentFeeEvents": {
                    "type": ".squareup.esperanto.api.PerPaymentFeeEvents",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PerPaymentFeeEvents": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeEvents": {
                    "type": ".squareup.esperanto.common.ProcessingFeeEvent",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "appFeeEvents": {
                    "type": ".squareup.esperanto.common.AppFeeEvent",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "AddFeeEventsResponse": {
                "fields": {
                  "failures": {
                    "type": ".squareup.esperanto.api.AddFeeEventsFailure",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "AddFeeEventsFailure": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.esperanto.api.AddFeeEventsFailure.AddFeeEventsError",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AddFeeEventsError": {
                    "values": {
                      "DEFAULT_ENUM_DO_NOT_USE": 0,
                      "INVALID_REQUEST": 1,
                      "PAYMENT_NOT_FOUND": 2,
                      "DIFFERENT_FEE_EVENTS_WITH_SAME_ID": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AddFeeEventsRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PerPaymentFeeEvents && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AddFeeEventsResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AddFeeEventsFailure && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AddFeeEventsFailure?.nested?.AddFeeEventsError) {
  $root.addJSON(jsonData);
}

/**
 * Request to add fee events to one or more payments
 *
 * SOURCE AddFeeEventsRequest @ squareup/esperanto/api/fee_events.proto at 11:1
 */
export const AddFeeEventsRequest = $root.lookupType('squareup.esperanto.api.AddFeeEventsRequest');
fixType(AddFeeEventsRequest);
Builder.createAndAttachToType(AddFeeEventsRequest);
/**
 * Fee events to add for a single payment
 *
 * SOURCE PerPaymentFeeEvents @ squareup/esperanto/api/fee_events.proto at 16:1
 */
export const PerPaymentFeeEvents = $root.lookupType('squareup.esperanto.api.PerPaymentFeeEvents');
fixType(PerPaymentFeeEvents, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(PerPaymentFeeEvents);
/**
 * Response to adding fee events
 *
 * SOURCE AddFeeEventsResponse @ squareup/esperanto/api/fee_events.proto at 25:1
 */
export const AddFeeEventsResponse = $root.lookupType('squareup.esperanto.api.AddFeeEventsResponse');
fixType(AddFeeEventsResponse);
Builder.createAndAttachToType(AddFeeEventsResponse);
/**
 * Error for a single payment
 *
 * SOURCE AddFeeEventsFailure @ squareup/esperanto/api/fee_events.proto at 30:1
 */
export const AddFeeEventsFailure = $root.lookupType('squareup.esperanto.api.AddFeeEventsFailure');
fixType(AddFeeEventsFailure);
Builder.createAndAttachToType(AddFeeEventsFailure);
/**
 * SOURCE AddFeeEventsError @ squareup/esperanto/api/fee_events.proto at 31:3
 */
AddFeeEventsFailure.AddFeeEventsError = $root.lookupEnum('squareup.esperanto.api.AddFeeEventsFailure.AddFeeEventsError').values;